import React from 'react';

// The EyeFleet brand lockup (eye icon + wordmark). It's a wide image, so it's
// sized by height with width kept at the natural aspect ratio.
export function Logo({ height = 30, style }: { height?: number; style?: React.CSSProperties }) {
  return (
    <img
      src="/logo/LogoEyeFleet-new.webp"
      alt="EyeFleet"
      height={height}
      style={{ height, width: 'auto', display: 'block', ...style }}
    />
  );
}
